import { Navigate, useLocation } from "react-router-dom";
import { urls } from "../../urls";
import { currentPathSuffix } from "./returnTo";

export const LoginRedirect = () => {
  const location = useLocation();
  return <Navigate to={urls.loginWithReturnUrl(currentPathSuffix(location))} replace />;
};
